import { inject, Service } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { switchMap, filter, map, take, tap } from 'rxjs';
import { CountryCodeStore } from '@public/src/app/store/store-access/country-code.store';


@Service()
export class CountryCodeInteractor {
  private readonly countryCodeStore = inject(CountryCodeStore);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  setGlobalCountryCode() {
    return this.router.events
      .pipe(
        filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd),
        take(1),
        switchMap(() => this.activatedRoute.queryParams),
        take(1),
        map(qp => qp['countryCode'] ?? null),
        filter((cc: string | null) => cc !== null),
        tap((countryCode: string) => this.countryCodeStore.setCountryCode(countryCode)),
      ).subscribe();
  }
}
